import {
  CAMPAIGN_LIST_REQUEST,
  CAMPAIGN_LIST_SUCCESS,
  CAMPAIGN_LIST_FAIL,
} from "../constant/CampaignConstant";
import api from "../core/api";

export const getCampaignList = (branchId) => async (dispatch, getState) => {
  try {
    dispatch({
      type: CAMPAIGN_LIST_REQUEST,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    
    let url = "";
    if (branchId.toString() != "0")
      url = `/campaign/activeCampaigns/branch/${branchId}`;
    else url = `/campaign`;
    const { data } = await api.get(url, config);

    var dt = data.Result;

    if (dt.includes("Error")) {
      dispatch({
        type: CAMPAIGN_LIST_FAIL,
        payload: dt,
      });
    } else {
      dispatch({
        type: CAMPAIGN_LIST_SUCCESS,
        payload: dt,
      });
    }
  } catch (error) {
    dispatch({
      type: CAMPAIGN_LIST_FAIL,
      payload:
        error.response && error.response.data
          ? error.response.data
          : error.message,
    });
  }
};
